import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  MenuItem,
  Breadcrumbs,
  Link,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Popover,
  Modal,
  Pagination,
  Select,
} from "@mui/material";
import CloseIcon from "../../assets/landing_page/new/closeicon.svg";
import { Delete as DeleteIcon, Edit as EditIcon, ChangeCircle as ChangeCircleIcon, MoreVert as MoreVertIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from "react-router-dom";
import http from "../../utils/http-common";
import { toast } from "react-toastify";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
const ViewResource = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const planId = localStorage.getItem("plan_id");
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  
  const cellStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 500,
    textAlign: "left",
  };
  const dataStyle = {
    fontFamily: "Inter, sans-serif",
    padding: "5px",
    fontSize: "10px",
    fontWeight: 500,
    textAlign: "left",
  };
  const ITEMS_PER_PAGE = 10;


const [resources, setResources] = useState([]);

  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await http.post("master_service/plan_role/user/mapping/details", { plan_id: planId });
        if (response.data?.mappings?.length > 0) {
          const fetchedResources = response.data.mappings.map((item, index) => ({
            id: index + 1,
            name: item.user?.user_name || "",
            email: item.user?.email || "",
            role_id: item.planRole?.metadata_id || "",
            role_name: item.planRole?.metadata_name || "",
          }));
          setResources(fetchedResources);
        }
      } catch (error) {
      console.error("Error fetching resources:", error);
      if (error.response?.status === 404) {
        console.error("Error 404 : No resources found for this plan.");
        setResources([]);
      }
    }
    };

    fetchDetails();
  }, [planId]);
  const fetchDetails = async () => {
    try {
      const response = await http.post("master_service/plan_role/user/mapping/details", { plan_id: planId });
      if (response.data?.mappings?.length > 0) {
        const fetchedResources = response.data.mappings.map((item, index) => ({
          id: index + 1,
          name: item.user?.user_name || "",
          email: item.user?.email || "",
          role_id: item.planRole?.metadata_id || "",
          role_name: item.planRole?.metadata_name || "",
        }));
        setResources(fetchedResources);
      }
    } catch (error) {
      console.error("Error fetching resources:", error);
      if (error.response?.status === 404) {
        console.error("Error 404 : No resources found for this plan.");
        setResources([]);
      }
    }
  };
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await http.post("master_service/template/category_list", { metadata_type: "PLANROLE" });
        if (response.data?.data) {
          const roleOptions = response.data.data.map((role) => ({
            id: role.metadata_id,
            name: role.metadata_name,
          }));
          setRoles(roleOptions);
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();
  }, []);

  const handleAddResource = () => {
    const teamMemberRole = roles.find(role => role.name === "Team Member");
    setResources([
      { id: resources.length + 1, name: "", email: "", role_id: teamMemberRole ? teamMemberRole.id : "" },
      ...resources,
    ]);
  };

  const [page, setPage] = useState(1);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const paginatedResources = resources.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  const handleDeleteResource = async (id) => {
    try {
      const resourceToDelete = resources.find(resource => resource.id === resourceId.id);
      const payload = [{
        plan_id: planId,
        email: resourceToDelete.email,
        name: resourceToDelete.name,
        plan_role_id: resourceToDelete.role_id
      }];

      const response = await http.post("master_service/planrole/resource/delete", payload);

      // Update local state after successful API call
      const updatedResources = resources.filter((resource) => resource.id !== resourceId.id);
      setResources(updatedResources);
      toast.success(response.data.message || "Resource deleted successfully");
      handleClose2();
    } catch (error) {
      console.error("Error deleting resource:", error);
      toast.error(error.response?.data?.message || "Failed to delete resource");
    }
  };

  const handleChange = (id, field, value) => {
    setResources((prevResources) =>
      prevResources.map((resource) =>
        resource.id === id ? { ...resource, [field]: value } : resource
      )
    );
  };

  const handleNavigate = () => {
    navigate("/home/myplans");
  };
const handleCreate = async () => {
    let payload;
    if (resourceData.role_id) {
      if (!resourceData) {
        toast.error("Resource data is missing.");
        return;
      }
    
      // Validation with optional chaining (?.) to avoid undefined errors
      if (!resourceData.name?.trim()) {
        toast.error("User Name is required.");
        return;
      }
      if (!resourceData.email?.trim()) {
        toast.error("Email ID is required.");
        return;
      }
      if (!resourceData.role_id) {
        toast.error("Role selection is required.");
        return;
      }
      payload = [{
        plan_id: planId,
        name: resourceData.name,
        email: resourceData.email,
        plan_role_id: resourceData.role_id,
      }];
    } else {
      if (!resourceId.name.trim()) {
        toast.error("User Name is required.");
        return;
      }
      if (!resourceId.email.trim()) {
        toast.error("Email ID is required.");
        return;
      }
      if (!resourceId.role_id) {
        toast.error("Role selection is required.");
        return;
      }
      payload = [{
        plan_id: planId,
        name: resourceId.name,
        email: resourceId.email,
        plan_role_id: resourceId.role_id,
      }];
    }
    
    
    try {
      const response = await http.post("master_service/create/plan_role/user/mapping", payload);
      toast.success(
        <>
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
            }}>
            Resources created successfully
          </div>
          </>,
        {
          icon: (
            <img
              src={tick}
              alt='Success Icon'
              style={{ width: "20px", height: "20px", color: "#0057D5" }}
            />
          ),
        }
      );
      setResourceData({
      name: "",
      email: "",
      role_id: "",
    });
      setOpen2(false);
      setOpen1(false);
      setAnchorEl(null);
      fetchDetails();
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to Create resource");
    }
  };
  const handleUpdate = async () => {
    let payload;
    if (resourceData.role_id) {
      if (!resourceData) {
        toast.error("Resource data is missing.");
        return;
      }
    
      // Validation with optional chaining (?.) to avoid undefined errors
      if (!resourceData.name?.trim()) {
        toast.error("User Name is required.");
        return;
      }
      if (!resourceData.email?.trim()) {
        toast.error("Email ID is required.");
        return;
      }
      if (!resourceData.role_id) {
        toast.error("Role selection is required.");
        return;
      }
      payload = [{
        plan_id: planId,
        name: resourceData.name,
        email: resourceData.email,
        plan_role_id: resourceData.role_id,
      }];
    } else {
      if (!resourceId.name.trim()) {
        toast.error("User Name is required.");
        return;
      }
      if (!resourceId.email.trim()) {
        toast.error("Email ID is required.");
        return;
      }
      if (!resourceId.role_id) {
        toast.error("Role selection is required.");
        return;
      }
      payload = [{
        plan_id: planId,
        name: resourceId.name,
        email: resourceId.email,
        plan_role_id: resourceId.role_id,
      }];
    }
    
    
    try {
      const response = await http.post("master_service/update/plan_role/user/mapping", payload);
      toast.success(
        <>
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
            }}>
            Resources updated successfully
          </div>
          </>,
        {
          icon: (
            <img
              src={tick}
              alt='Success Icon'
              style={{ width: "20px", height: "20px", color: "#0057D5" }}
            />
          ),
        }
      );
      setResourceData({
      name: "",
      email: "",
      role_id: "",
    });
      setOpen2(false);
      setOpen1(false);
      setAnchorEl(null);
      fetchDetails();
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to Create resource");
    }
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [resourceId, setResourceId] = useState({});
  const [userName, setUserName] = useState([]);
  const [emailID, setEmailID] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [resourceData, setResourceData] = useState({
    name: "",
    email: "",
    role_id: "",
  });
  
  const handleInputChange = (field, value) => {
    setResourceData((prev) => ({ ...prev, [field]: value }));
  };

  const handleActionOpen = (event, id, resource) => {
    setResourceId(resource);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseAction = () => {
    setAnchorEl(null);
  };

  const handleOpen = () => {
    setOpen1(true); // Only open if it's not being dragged
  };
  const handleClose = () => {
    setOpen1(false);
  };
  const handleOpen1 = () => {
    setOpen2(true); // Only open if it's not being dragged
  };
  const handleClose1 = () => {
    setOpen2(false);
  };
  const handleOpen2 = () => {
    setOpen3(true); // Only open if it's not being dragged
  };
  const handleClose2 = () => {
    setOpen3(false);
  };

  return (
    <Container maxWidth={false}  sx={{ 
    width: "100%",
    paddingLeft: "0 !important",
    paddingRight: "0 !important"
}}>
      <div
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: "16px",
          fontWeight: 600,
          lineHeight: "21px",
          marginLeft: "8px"
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h6" sx={{fontSize: "16px"}}>Resources</Typography>
          <Button variant="contained" onClick={handleOpen1} sx={{
            background: "#FF2800", fontSize: "12px", textTransform: "capitalize", cursor: "pointer", "&:hover": {
              backgroundColor: "#FF2800",
            },
          }}>
            + New Resource
          </Button>
        </Box>
      </div>
      <div>
<TableContainer component={Paper}>
  <Table size="small" sx={{ minWidth: 150 }} aria-label="user table">
    <TableHead sx={{ backgroundColor: "#e0eaff", height: "30px" }}>
      <TableRow>
        <TableCell sx={cellStyle}>S.No</TableCell>
        <TableCell sx={cellStyle}>Name</TableCell>
        <TableCell sx={cellStyle}>Email ID</TableCell>
        <TableCell sx={cellStyle}>Role</TableCell>
        <TableCell sx={cellStyle}></TableCell>
      </TableRow>
    </TableHead>
    <TableBody sx={{ height: "10px" }}>
      {resources.length > 0 ? (
        paginatedResources.map((resource, index) => (
          <TableRow key={resource.id} sx={{ height: "10px" }}>
            <TableCell sx={dataStyle}>{startIndex + index + 1}</TableCell>
            <TableCell sx={dataStyle}>{resource.name}</TableCell>
            <TableCell sx={dataStyle}>{resource.email}</TableCell>
            <TableCell sx={dataStyle}>{resource.role_name}</TableCell>
            <TableCell>
              <IconButton onClick={(event) => handleActionOpen(event, resource.id, resource)}>
                <MoreVertIcon sx={{ height: "20px", width: "20px" }} />
              </IconButton>
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={5} align="center" sx={{py: 3,
            color: "#666",
          }}>
            No resources available
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
</TableContainer>
        <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
          <Pagination
            count={Math.ceil(resources.length / ITEMS_PER_PAGE)}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>

      </div>
      <Popover
        id="user-options-popover"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseAction}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box sx={{ p: 1, width: "150px" }}>
          <>
            <Button onClick={handleOpen} fullWidth sx={{ justifyContent: "flex-start", color: "black" }}>
              <EditIcon fontSize="small" sx={{ mr: 1 }} />
              <Typography variant="body1" sx={{ fontSize: "12px", textTransform: "capitalize", fontWeight: 500 }}>Edit Resources</Typography>
            </Button>
            <Button onClick={handleOpen2} fullWidth sx={{ justifyContent: "flex-start", color: "black" }}>
              <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
              <Typography variant="body1" sx={{ fontSize: "12px", textTransform: "capitalize", fontWeight: 500 }}>Remove Access</Typography>
            </Button>
          </>
        </Box>
      </Popover>
      <Modal open={!!open1} onClose={handleClose} resourceId={resourceId}>  
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "370px", // Reduced width slightly
      height: "200px", // Reduced height
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: "10px",
    }}
  >
    {/* Close Icon */}
    <IconButton
      onClick={handleClose}
      sx={{
        position: "absolute",
        top: 8,
        right: 8,
        color: "grey",
      }}
    >
      <img
        src={CloseIcon}
        alt="closeIcon"
        style={{ width: "20px", height: "20px" }}
      />
    </IconButton>

    {/* Form Fields */}
    <Box sx={{ width: "100%", mt: -2}}>
    <Typography style={{ fontSize: "14px", fontWeight: 600 }} gutterBottom>
      Edit Resource
    </Typography> 
      <Typography style={{ fontSize: "10px", fontWeight: 500 }} gutterBottom>
        User Name
      </Typography>
      <TextField
        sx={{ width: "100%" }} 
        size="small"
        placeholder="Enter User Name"
        value={resourceId?.name || ""}
        onChange={(e) => setResourceId({ ...resourceId, name: e.target.value })}
        InputProps={{ sx: { height: 30, fontSize: "12px" } }} // Reduced height
      />

      <Typography style={{ fontSize: "10px", fontWeight: 500 }} gutterBottom>
        Email
      </Typography>
      <TextField
        sx={{ width: "100%" }} 
        size="small"
        placeholder="Enter Email Id"
        value={resourceId?.email || ""}
        onChange={(e) => setResourceId({ ...resourceId, email: e.target.value })}
        InputProps={{ sx: { height: 30, fontSize: "12px" } }} // Reduced height
      />

      <Typography style={{ fontSize: "10px", fontWeight: 500 }} gutterBottom>
        Role
      </Typography>
      <TextField
        sx={{ width: "100%" }} 
        select
        size="small"
        value={resourceId?.role_id || ""}
        onChange={(e) => {
          const selectedRole = roles.find((role) => role.id === e.target.value);
          if (selectedRole) {
            setResourceId({
              ...resourceId,
              role_id: selectedRole.id, // Store ID
              role_name: selectedRole.name, // Store Name for display purposes
            });
          }
        }}
        InputProps={{ sx: { height: 30, fontSize: "12px" } }} // Reduced height
      >
        {roles.map((role) => (
          <MenuItem key={role.id} value={role.id}>
            {role.name}
          </MenuItem>
        ))}
      </TextField>
    </Box>

    {/* Submit Button */}
    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
      <Button
        variant="contained"
        style={{
          backgroundColor: "#FF2800",
          color: "white",
          padding: "3px 10px",
          textTransform: "capitalize",
          cursor: "pointer",
        }}
        onClick={handleUpdate}
      >
        Update
      </Button>
    </Box>
  </Box>
</Modal>

      <Modal open={!!open2} onClose={handleClose1}>  
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "370px",  // Increased width slightly
      height: "200px", // Reduced height
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: "10px",
    }}
  >
    {/* Close Icon */}
    <IconButton
      onClick={handleClose1}
      sx={{
        position: "absolute",
        top: 8,
        right: 8,
        color: "grey",
      }}
    >
      <img
        src={CloseIcon}
        alt="closeIcon"
        style={{ width: "20px", height: "20px" }}
      />
    </IconButton>

    {/* Form Fields */}
    <Box sx={{ width: "100%", mt: -2 }}>
    <Typography style={{ fontSize: "14px", fontWeight: 600, margin: "3px" }} gutterBottom>
      Create Resource
    </Typography> 
      <Typography style={{ fontSize: "10px", fontWeight: 500 }} gutterBottom>
        User Name
      </Typography>
      <TextField
        sx={{ width: "100%" }}
        size="small"
        placeholder="Enter User Name"
        value={resourceData.name}
        onChange={(e) => handleInputChange("name", e.target.value)}
        InputProps={{ sx: { height: 30, fontSize: "12px" } }}
      />

      <Typography style={{ fontSize: "10px", fontWeight: 500 }} gutterBottom>
        Email
      </Typography>
      <TextField
        sx={{ width: "100%" }}
        size="small"
        placeholder="Enter Email Id"
        value={resourceData.email}
        onChange={(e) => handleInputChange("email", e.target.value)}
        InputProps={{ sx: { height: 30, fontSize: "12px" } }}
      />

      <Typography style={{ fontSize: "10px", fontWeight: 500 }} gutterBottom>
        Role
      </Typography>
      <TextField
        sx={{ width: "100%" }}
        select
        size="small"
        value={resourceData.role_id}
        onChange={(e) => handleInputChange("role_id", e.target.value)}
        InputProps={{ sx: { height: 30, fontSize: "12px" } }}
      >
        {roles.map((role) => (
          <MenuItem key={role.id} value={role.id}>
            {role.name}
          </MenuItem>
        ))}
      </TextField>
    </Box>
    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
      <Button
        variant="contained"
        style={{
          padding: "3px 10px",
          backgroundColor: "#FF2800",
          color: "white",
          textTransform: "capitalize",
          cursor: "pointer",
        }}
        onClick={handleCreate}
      >
        Create
      </Button>
    </Box>
  </Box>
</Modal>
      <Modal open={!!open3} onClose={handleClose2} resourceId={resourceId}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "350px",
            bgcolor: "background.paper",
            boxShadow: 24,
            padding: '25px',
            paddingBottom: "10px",
            borderRadius: "10px",
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={handleClose2}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "grey",
            }}
          >
            <img
              src={CloseIcon}
              alt='closeIcon'
              style={{ width: "20px", height: "20px" }}
            />
          </IconButton>
          <Box sx={{ width: "100%", mt: -2 }}>
  <Typography
    style={{
      fontSize: "14px",
      fontWeight: 600,
      margin: "3px 0",
      marginLeft: -7,
      textAlign: "left",  // Align text to the left
    }}
    gutterBottom
  >
    Remove Access
  </Typography>

  <Typography
    style={{
      fontSize: "12px",
      fontWeight: 500,
      textAlign: "left",  // Align text to the left
      marginLeft: -7,
    }}
    gutterBottom
  >
    Are you sure you want to remove access for the resource?
  </Typography>

  <Box
    sx={{
      display: "flex",
      justifyContent: "flex-start", // Align buttons to the left
      gap: 2,
      mt: 1, // Add top margin to move buttons down
      ml: -1,
      alignItems: 'flex-start'
    }}
  >
    <Button
      variant="contained"
      style={{
        minWidth: "170px", // Increased button width
        padding: "6px 20px",
        backgroundColor: "#FFF",
        color: "black",
        border: "1px solid gray",
        textTransform: "capitalize",
        cursor: "pointer",
      }}
      onClick={handleClose2}
    >
      Cancel
    </Button>
    <Button
      variant="contained"
      style={{
        minWidth: "170px", // Increased button width
        padding: "6px 20px",
        backgroundColor: "#FF2800",
        color: "white",
        textTransform: "capitalize",
        cursor: "pointer",
      }}
      onClick={handleDeleteResource}
    >
      Remove Access
    </Button>
  </Box>
</Box>

        </Box>
      </Modal>
    </Container>
  );
};

export default ViewResource;
